import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { AppCheck, initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'commercial-excellence.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Validar que todas las variables de entorno estén presentes
const requiredEnvVars = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
];

requiredEnvVars.forEach((varName) => {
  if (!import.meta.env[varName]) {
    throw new Error(`Missing required environment variable: ${varName}`);
  }
});

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export let appCheck: AppCheck | null = null;

const appCheckSiteKey = '6LehZtwsAAAAAA__-x_Ww8zZ7dsmPYidAE24KDHs';
const appCheckDebugToken = import.meta.env.VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN;
const shouldEnableAppCheck = !import.meta.env.DEV || Boolean(appCheckDebugToken);

if (import.meta.env.DEV && appCheckDebugToken) {
  (globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN =
    appCheckDebugToken === 'true' ? true : appCheckDebugToken;
}

if (import.meta.env.DEV) {
  const resolvedDebugToken = (globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN;
  if (!appCheckDebugToken) {
    console.info(
      '[AppCheck] VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN no definido. Para generar un debug token, configúralo en "true" y recarga; el SDK lo imprimirá en consola.'
    );
  } else {
    console.info('[AppCheck] VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN:', appCheckDebugToken);
  }
  if (resolvedDebugToken !== undefined) {
    console.info('[AppCheck] FIREBASE_APPCHECK_DEBUG_TOKEN (runtime):', resolvedDebugToken);
  }
}

if (!shouldEnableAppCheck) {
  console.warn(
    'Firebase App Check desactivado en local. Configura VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN para probarlo en desarrollo.'
  );
} else if (appCheckSiteKey) {
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (error) {
    console.error('Error initializing Firebase App Check:', error);
  }
}

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Configure Google Provider
googleProvider.setCustomParameters({
  prompt: 'select_account',
});

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage
export const storage = getStorage(app);
